// Add vanilla components here
import('../Vanilla/SearchResult');
import('../Vanilla/VariantColorSelector');
